import { actions, categories } from '@/constants/analytics.js';

const mirrorNavigation = {
  computed: {
    currentMirrorIndex() {
      const { id } = this.slug || {};
      return this.filteredMirror.findIndex(mirror => mirror.id === id);
    },
    nextMirror() {
      return this.filteredMirror[this.currentMirrorIndex + 1];
    },
    previousMirror() {
      return this.filteredMirror[this.currentMirrorIndex - 1];
    },
  },
  methods: {
    handlerPagination(type) {
      if (type === 'next' ? !this.nextMirror : !this.previousMirror)
        return false;

      const reference = this.getReference(type);

      this.sendMirrorCardAnalytics();

      this.$store.dispatch('mirror/handleLastMirror', reference);

      this.changeSelectedMirrorItem(type);
    },

    getReference(type) {
      const slugId = this.getNextOrPreviousMirrorId(type);
      return `mirror-${slugId}`;
    },

    getNextOrPreviousMirrorId(type) {
      return type === 'next' ? this.nextMirror.id : this.previousMirror.id;
    },

    sendMirrorCardAnalytics() {
      const { place, program_tag, title } = this.slug || {};
      this.$store.dispatch('analyticsEvent', {
        category: categories.mirror,
        action: actions.activityDetailClicked,
        label: `${place}-${program_tag}-${title}`,
      });
    },
  },
};

export default mirrorNavigation;
